import { render, staticRenderFns } from "./reset.vue?vue&type=template&id=5e828652&scoped=true&"
import script from "./reset.vue?vue&type=script&lang=ts&"
export * from "./reset.vue?vue&type=script&lang=ts&"
import style0 from "./reset.vue?vue&type=style&index=0&id=5e828652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e828652",
  null
  
)

export default component.exports